import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import './plugins/apex-charts';
import store from './store'
import './plugins/vee-validate';
import './plugins/v-money';
import './plugins/vue-dropzone';

import './styles/custom.scss'
import './styles/custom.css'
import './styles/app.css'
import './styles/app.scss'
//import './styles/_bootstrap-extras.scss'
import vSelect from 'vue-regex-input';
import acl from './plugins/acl';
import alertMixin from "@/mixins/messageAlert";
import { formatDocument } from '@/utils/document';
// import VueGtm from 'vue-gtm';

Vue.mixin(alertMixin);
// Helpers globais para exibição de CPF/CNPJ (inclusive CNPJ alfanumérico).
// Filtro: {{ valor | formatDocument }} | Método: {{ $formatDocument(valor) }} (uso em expressões).
Vue.filter('formatDocument', formatDocument);
Vue.prototype.$formatDocument = formatDocument;
Vue.component('vue-regex-input', vSelect);
Vue.config.productionTip = false

Vue.use(acl);

// Configurar GTM apenas se o ID estiver definido
// if (process.env.VUE_APP_GTM_ID) {
//   try {
//     Vue.use(VueGtm, {
//       id: process.env.VUE_APP_GTM_ID,
//       defer: false,
//       enabled: true,
//       debug: false,
//       loadScript: true,
//       vueRouter: router,
//       trackOnNextTick: false,
//     });
//   } catch (error) {
//     console.warn('GTM initialization failed:', error);
//   }
// }

import CopyButton from '@/components/Commons/CopyButton.vue'

Vue.component('CopyButton', CopyButton)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


